import { FC, useEffect, useState } from 'react';
import { Modal, TextAreaInput } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';

const QuoteModal: FC<CommonModalProps<string>> = ({
  isOpen,
  onClose,
  onSubmit,
  data,
}) => {
  const [quote, setQuote] = useState(data || '');

  useEffect(() => {
    data && setQuote(data);
  }, [data]);

  return (
    <Modal
      title="Quote Modal"
      open={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit && onSubmit(quote)}
    >
      <TextAreaInput
        name="quote"
        rows={20}
        value={quote}
        onChange={(name, value) => setQuote(value)}
      />
    </Modal>
  );
};

export default QuoteModal;
